@if (vm().isLoading && vm().items.length === 0) {
  <lib-skeleton-card-two-columns></lib-skeleton-card-two-columns>
  <lib-spinner-loading></lib-spinner-loading>
  <lib-skeleton-card-two-columns></lib-skeleton-card-two-columns>
} @else if (vm().error && vm().items.length === 0) {
  <div class="ion-text-center ion-padding">
    <p class="fs-sm">{{ 'market.load_error' | translate }}</p>
    <ion-button
      size="small"
      (click)="retry.emit()"
      >{{ 'general.retry' | translate }}</ion-button
    >
  </div>
} @else {
  @for (freight of vm().items; track freight.id) {
    <lib-freight-available-card [freight]="freight"></lib-freight-available-card>
  } @empty {
    <lib-empty-result text="market.empty_freights"></lib-empty-result>
  }

  @if (vm().isLoadingMore) {
    <lib-skeleton-card-two-columns></lib-skeleton-card-two-columns>
    <p class="fs-xs ion-text-center ion-padding">{{ 'general.loading_data' | translate }}</p>
    <lib-skeleton-card-two-columns></lib-skeleton-card-two-columns>
  }

  @if (vm().error && vm().items.length > 0) {
    <div class="ion-text-center ion-padding">
      <p class="fs-xs">{{ 'market.load_error' | translate }}</p>
      <ion-button
        size="small"
        fill="outline"
        (click)="retry.emit()"
      >
        {{ 'general.retry' | translate }}
      </ion-button>
    </div>
  }

  @if (vm().hasMore) {
    <ion-infinite-scroll
      [disabled]="vm().isLoading || vm().isLoadingMore || vm().isStale || !!vm().error"
      (ionInfinite)="onIonInfinite($event)"
    >
      <ion-infinite-scroll-content [loadingText]="'general.loading_data' | translate"></ion-infinite-scroll-content>
    </ion-infinite-scroll>
  }
}
